import React, { useState } from 'react';
import { Row } from 'reactstrap';
import BoldButton from '../../Common/BoldButton';
import OrderTransactionDto from '../../Common/dtos/OrderTransactionDto';
import { Profile } from '../../UserAccess/UserContext';
import OrderDto from '../../Common/dtos/OrderDto';
import useOrderTransactionsByOrder from '../../../requests/useOrderTransactionsByOrder';
import QueryView from '../../Common/QueryView';
import { dateSort } from '../../../Utilities';
import { OrderTransactionView } from './OrderTransactionView';
import KaAlert from '../../Common/KaAlert';
import useDisplayMessage from '../../Common/useDisplayMessage';

interface IProps {
  profile: Profile,
  order: OrderDto,
  orderTransactionId?: string,
  backClicked?: () => void,
  viewOnly?: boolean
}

const OrderTransactionPage = (props: IProps) => {
  const getOrderTransactions = useOrderTransactionsByOrder(props.order.id, "Pound");
  const [transactionToVoid, setTransactionToVoid] = useState<OrderTransactionDto | null>(null);
  const displayMessage = useDisplayMessage();

  const handleVoidSuccess = () => {
    displayMessage.success(`Order transaction ${transactionToVoid?.number} has been voided successfully.`);
    getOrderTransactions.query();
    setTransactionToVoid(null);
  };

  const filterTransactions = (ots: OrderTransactionDto[]) =>
    props.orderTransactionId ? ots.filter(ot => ot.id === props.orderTransactionId) : ots;

  return <>
    <h2 className="col-auto ka-blue">Order Transactions</h2>
    <Row className="justify-content-between mb-2">
      <BoldButton className="col-auto btn-ghost-secondary" variant="link" onClick={props.backClicked}>
        <i className="bi-chevron-left" /> Back
      </BoldButton>
    </Row>
    <KaAlert displayMessage={displayMessage.message} onClose={displayMessage.clear} />
    <QueryView
      query={getOrderTransactions}
      renderData={ots => <>
        {ots?.length === 0 && <h4>No Order Transactions found for Order {props.order.number}</h4>}
        <Row>
          <div>
            {filterTransactions(dateSort(ots, 'loadedAt')).map(orderTransaction =>
              <OrderTransactionView 
                orderTransaction={orderTransaction} 
                key={`orderTransaction-${orderTransaction.id}`} 
                setOrderTransactionToVoid={setTransactionToVoid} 
                handleVoidSuccess={handleVoidSuccess}
                viewOnly={props.viewOnly} />
            )}
          </div>
        </Row>
      </>
      }
    />
  </>
}

export { OrderTransactionPage };
